// extracted by mini-css-extract-plugin
module.exports = {"priceWrapper":"priceWrapper--KV515","note":"note--2w2qC"};